import React from 'react';
import {
  Container,
  Row,
  Col,
  CirclePlusIcon,
  IconButton,
  SearchInput,
  SearchIcon,
} from 'shared-portal-component';

import '@/components/organism/Administrators/AdministratorsHeader/AdministratorsHeader.scss';

interface AdministratorsHeaderProps {
  onCreate: () => void;
   searchValue: string;
  onSearchChange: (value: string) => void;
}

const AdministratorsHeader: React.FC<AdministratorsHeaderProps> = ({ onCreate,
  searchValue,
  onSearchChange}) => (
  <Container fluid className="administrators-header">
    <Row spacing="none" align="center" justify="between">
      <Col size="content">
        <SearchInput
          placeholder="Search Admins..."
          variant="outline"
          showRightIcon={false}
          leftIcon={<SearchIcon size="1x" />}
          value={searchValue}
          onChange={(e: { target: { value: string; }; }) => { onSearchChange(e.target.value); }}
        />
      </Col>
      <Col size="content">
        <IconButton
          ariaLabel="Add administrator"
          variant="secondary"
          size="md"
          icon={<CirclePlusIcon size="2x" />}
          onClick={onCreate}
        />
      </Col>
    </Row>
  </Container>
);

export default AdministratorsHeader;
